import { invoiceSentStatusEvents } from '../constants/invoiceSentStatusEvents'
import { InvoiceEventType } from '../enums/invoiceEventType'
import { InvoiceEvent } from '../types/invoices/invoiceEvent'
import { isInvoiceManuallyMarkedAsSent } from './isInvoiceManuallyMarkedAsSent'

export const hasInvoiceSentStatus = (events: InvoiceEvent[] = []): boolean => {
  const hasAutomaticSentEvent = events.some(
    (event) =>
      invoiceSentStatusEvents.includes(event.eventType) && event.eventType !== InvoiceEventType.DeliveryManualSent,
  )

  return hasAutomaticSentEvent || isInvoiceManuallyMarkedAsSent(events)
}
